import clsx from "clsx";

type Props = {
	scale?: number;
	size?: "sm" | "md" | "lg";
	theme?: "default" | "neutral";
};

const sizeClasses = { sm: "size-4 border-2", md: "size-6 border-4", lg: "size-10 border-4" };

function LoadingSpinner({ scale, size = "md", theme = "default" }: Props) {
	return (
		<div style={{ transform: `scale(${scale})` }}>
			<div className={clsx(sizeClasses[size], "animate-spin rounded-[50%]", theme === "neutral" ? "border-gray-200 border-t-gray-500" : "border-white border-t-secondary-500")} />
		</div>
	);
}

export default LoadingSpinner;
